import { Css, DeepPartial, ITheme } from '@/ui';
import { Color } from './Color';

export const themeOXD: DeepPartial<ITheme> = {
	callToAction: {
		background: {
			default: Color.Neutral94,
			inverted: Color.OxdPrimary,
			secondary: Color.OXDSecondary,
		},
		font: {
			color: {
				default: Color.OxdPrimary,
				inverted: Color.OnPrimarySurface,
				secondary: Color.OXDSecondary20,
			},
		},
	},
	color: {
		highlight: Color.OxdPrimary,
		brand: Color.OxdPrimary,
		background: {
			default: Color.OnPrimarySurface,
			light: Color.OXDPrimary60,
			lighter: Color.OXDPrimaryLight,
		},
		text: {
			default: Color.OnBackgroundText,
			inverted: Color.OnPrimarySurface,
			light: Color.Neutral40,
		},
		border: {
			default: `1px solid ${Color.Neutral80}`,
		},
	},
	typography: {
		link: {
			hover: {
				color: Color.OxdPrimary,
			},
			color: Color.OxdPrimary,
		},
	},
	card: {
		featureEntryPoint: {
			icon: {
				color: Color.OxdPrimary,
				backgroundColor: Color.OXDPrimaryLight,
			},
		},
	},
	blockquote: {
		boxShadow: `inset ${Css.pxToRem(4)} 0 0 0 ${Color.OxdPrimary}`,
	},
	button: {
		primary: {
			background: Color.OxdPrimary,
			border: `1px solid ${Color.OxdPrimary}`,
			font: {
				color: Color.OnPrimarySurface,
			},
			hover: {
				background: Color.OXDPrimary60,
				font: {
					color: Color.OXDBlack,
				},
			},
			focus: {
				background: Color.OXDPrimary70,
				border: `1px solid ${Color.OxdPrimary}`,
				font: {
					color: Color.OXDBlack,
				},
			},
			active: {
				background: Color.OXDPrimary70,
			},
			disabled: {
				border: `1px solid ${Color.Neutral94}`,
				background: Color.Neutral94,
				font: {
					color: Color.Neutral30,
				},
			},
			inverted: {
				background: Color.OnPrimarySurface,
				border: `1px solid ${Color.OxdPrimary}`,
				font: {
					color: Color.OxdPrimary,
				},
				hover: {
					background: Color.OXDPrimary60,
					border: `1px solid ${Color.OxdPrimary}`,
					font: {
						color: Color.OXDBlack,
					},
				},
				focus: {
					background: Color.OXDPrimary70,
					font: {
						color: Color.OXDBlack,
					},
				},
				active: {
					background: Color.OXDPrimary70,
				},
			},
			invertedSecondary: {
				background: Color.OnPrimarySurface,
				border: `1px solid ${Color.OnPrimarySurface}`,
				font: {
					color: Color.OXDSecondary20,
				},
				hover: {
					border: `1px solid ${Color.OXDSecondary20}`,
					background: Color.OXDSecondary20,
					font: {
						color: Color.OnPrimarySurface,
					},
				},
				focus: {
					background: Color.OXDSecondary20,
					border: `1px solid ${Color.OXDSecondary20}`,
					font: {
						color: Color.OnPrimarySurface,
					},
				},
				active: {
					background: Color.OXDSecondary20,
					border: `1px solid ${Color.OXDSecondary20}`,
					font: {
						color: Color.OnPrimarySurface,
					},
				},
			},
		},
		secondary: {
			border: `1px solid ${Color.OxdPrimary}`,
			font: {
				color: Color.OxdPrimary,
			},

			hover: {
				border: `1px solid ${Color.OxdPrimary}`,
				font: {
					color: Color.OXDBlack,
				},
				background: Color.OXDPrimary60,
			},
			focus: {
				background: Color.OXDPrimary70,
			},
			active: {
				border: `1px solid ${Color.OxdPrimary}`,
				background: Color.OXDPrimary70,
			},
			disabled: {
				border: `1px solid ${Color.Neutral50}`,
				font: {
					color: Color.Neutral30,
				},
			},
			inverted: {
				border: `1px solid ${Color.OnPrimarySurface}`,
				font: {
					color: Color.OnPrimarySurface,
				},
				hover: {
					border: `1px solid ${Color.OxdPrimary}`,
					background: Color.OXDPrimary70,
					font: {
						color: Color.OXDBlack,
					},
				},
				focus: {
					border: `1px solid ${Color.OxdPrimary}`,
					background: Color.OXDPrimary60,
					font: {
						color: Color.OXDBlack,
					},
				},
				active: {
					border: `1px solid ${Color.OxdPrimary}`,
					background: Color.OXDPrimary60,
					font: {
						color: Color.OXDBlack,
					},
				},
			},
			invertedSecondary: {
				border: `1px solid ${Color.OXDSecondary20}`,
				font: {
					color: Color.OXDSecondary20,
				},
				hover: {
					border: `1px solid ${Color.OXDSecondary20}`,
					background: Color.OXDSecondary20,
					font: {
						color: Color.OnPrimarySurface,
					},
				},
				focus: {
					background: Color.OXDSecondary20,
					font: {
						color: Color.OnPrimarySurface,
					},
				},
				active: {
					background: Color.OXDSecondary20,
					font: {
						color: Color.OnPrimarySurface,
					},
				},
			},
		},
	},
	select: {
		main: {
			background: Color.Neutral94,
			color: Color.OnBackgroundText,
		},

		focus: {
			borderBottom: `2px solid ${Color.OxdPrimary}`,
		},
	},
	input: {
		placeholder: {
			color: Color.OxdPrimary,
			focussed: {
				color: Color.OxdPrimary,
			},
		},
	},
	dropdownList: {
		option: {
			highlighted: {
				color: Color.OxdPrimary,
			},
		},
	},
	siteSection: {
		backgroundColor: Color.OXDPrimaryLight,
		color: Color.OxdPrimary,
	},
	footer: {
		socialLinks: {
			color: Color.OxdPrimary,
			hover: {
				color: Color.OXDPrimary60,
			},
		},
	},
};
